// "act": null,
//   "act_reading": null,
//   "act_english": null,
//   "act_math": null,
//   "act_science": null,
//   "act_writing": null,

export const ACT_TESTING_TYPES = ['act'];
const isSat = (type: string) => ACT_TESTING_TYPES.includes(type);

interface StandardItem {
  type: string;
  total: number;
  reading: number;
  english: number;
  math: number;
  science: number;
  writing: number;
}

export default class SatConverter {
  static is = isSat;
  static isValid = (item: StandardItem) => {
    return (
      item.total > 0 ||
      item.reading > 0 ||
      item.english > 0 ||
      item.math > 0 ||
      item.science > 0 ||
      item.writing > 0
    );
  };

  static toArray(resume: Record<string, any>) {
    return ACT_TESTING_TYPES.map((type) => {
      return {
        type,
        ...resume['act_test_score'],
      };
    });
  }

  static toValidArray(resume: Record<string, any>) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }

  static toObject(items: StandardItem[]) {
    const resume = {};
    items.forEach((item) => {
      if (this.is(item.type)) {
        resume['act_test_score'] = item;
      }
    });
    return resume;
  }

  static toObjectV3(obj: Record<string, any>) {
    const resume = {};
    resume['act_test_score'] = {
      type: 'act',
      ...obj,
    };
    return resume;
  }

  static defaults() {
    return {
      act_test_score: {
        total: 0,
        reading: 0,
        english: 0,
        math: 0,
        science: 0,
        writing: 0,
      }
    };
  }
}
